/* eslint-disable */
import { message } from 'antd'
import { enableMapSet } from 'immer'

enableMapSet()

export const dva = {
  config: {
    onError(e) {
      e.preventDefault()
      console.log(e)
      message.destroy()
      if (e.message) {
        if (e.message == 'Failed to fetch') {
          message.error('请检查您的网络连接')
        } else {
          message.error(e.message)
        }
      }
    },
  },
  plugins: [],
}

sessionStorage.setItem('$XDataHost', 'https://query-panel.xiaoduoai.com/')

